import React, { useRef, useState } from "react";
import InputTextCounter from "components/shared/InputTextCounter";

const demoContainerStyles = {
  width: "400px"
};

const demoFormStyles = {
  alignItems: "center",
  display: "flex",
  gap: "2px",
  width: "100%"
};

const textAreaStyles = {
  height: "250px",
  width: "300px"
};

export default function InputTextCounterDemo() {
  const [props, setProps] = useState({
    disabled: false,
    inputClass: "input-lg",
    isRequired: true,
    labelText: "Label",
    max: 100,
    min: 10,
    name: "sample_name",
    placeholder: "Placeholder",
    value: "foo"
  });
  const [componentKey, setComponentKey] = useState(1);
  const [displayedProps, setDisplayedProps] = useState(
    JSON.stringify(props, null, " ")
  );
  const textAreaRef = useRef();

  const remountComponent = () => {
    // Force a remount of the component in test to allow for new props
    // to simulate a fresh render
    setComponentKey(componentKey + 1);
  };

  const handleClick = () => {
    setProps(JSON.parse(displayedProps));
    remountComponent();
  };

  const handleChangedProps = (e) => {
    setDisplayedProps(e.target.value);
  };

  const handleInputChange = (e) => {
    const newDisplayedProps = {
      ...JSON.parse(displayedProps),
      value: e.target.value
    };

    setDisplayedProps(JSON.stringify(newDisplayedProps, null, " "));
  };

  return (
    <div style={demoContainerStyles}>
      <div style={demoFormStyles}>
        <textarea
          style={textAreaStyles}
          ref={textAreaRef}
          value={displayedProps}
          onChange={handleChangedProps}
        />
        <button type="button" onClick={handleClick}>
          Update
        </button>
      </div>
      <InputTextCounter
        key={componentKey}
        onChange={handleInputChange}
        {...props}
      />
    </div>
  );
}
